<template>
    <div>
      <!-- Verifica el ancho de pantalla y muestra el componente adecuado -->
      <template v-if="isSmallScreen">
        <menumobile />
      </template>
      <template v-else>
        <menudesktop />
      </template>
    </div>
  </template>
  
  <script>
  import Menumobile from './MenuMobile.vue';
  import Menudesktop from './MenuDesktop.vue';
  
  export default {
    components: {
      Menumobile,
      Menudesktop,
    },
    data() {
      return {
        isSmallScreen: window.innerWidth < 600, // Verifica el ancho de pantalla al cargar
      };
    },
    mounted() {
      // Actualiza la variable isSmallScreen cuando cambia el tamaño de la pantalla
      window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
      // Elimina el oyente de eventos al destruir el componente
      window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
      checkScreenSize() {
        // Actualiza isSmallScreen cuando cambia el tamaño de la pantalla
        this.isSmallScreen = window.innerWidth < 600;
      },
    },
  };
  </script>
  